import { WsEvent } from '@shared/api'
import { useDisciplineStore } from '@entities/customer'
import { useActiveDisciplineInfoApi } from '@entities/customer'
import { onDisciplineReady } from '@entities/customer'

export const useListenEventDiscipline = (channel: any): void => {
  const disciplineStore = useDisciplineStore()

  onDisciplineReady(() => {
    channel.listen(WsEvent.DisciplineUpdated, async (event: any): Promise<void> => {
      if (disciplineStore.getInfoStatus(event.id) === 'idle') return

      void useActiveDisciplineInfoApi({ disciplineId: event.id, mode: 'refresh' })
    })
  })
}
